import React from "react";
import YouTube from "react-youtube";

const EmbeddedYouTubeVideo = ({ videoId }) => {
  const opts = {
    height: "360",
    width: "100%",
  };

  return <YouTube videoId={videoId} opts={opts} />;
};

export default EmbeddedYouTubeVideo;
